import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	position: relative;
`;

const StyledHint = styled.div`
	position: absolute;
	left: 50%;
	top: -40px;
	transform: translateX(-50%);
	padding: 10px;
	border-radius: 10px;
	background: rgba(255, 255, 255, 0.9);
	opacity: 1;
	transition: opacity 0.3s ease;

	&.hint-enter {
		opacity: 0;
	}

	&.hint-enter-active,
	&.hint-enter-done,
	&.hint-exit {
		opacity: 1;
	}

	&.hint-exit-active {
		opacity: 0;
	}

	${Text} {
		font-size: 14px;
		color: #000000;
	}
`;

export { StyledContainer, StyledHint };
